'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useButton } from '@react-aria/button';
import { Children, isValidElement, cloneElement } from 'react';
import { useSwanMenuTriggerContext } from './menu-trigger.context.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function MenuTrigger({ children: a }) {
    let { triggerRef: u } = useSwanPopover(), { triggerProps: b } = useSwanMenuTriggerContext(), { buttonProps: f } = useButton(b, u), l = _object_spread_props(_object_spread({}, f), {
        ref: u,
        type: void 0,
        className: 'swan-menu-trigger'
    });
    return jsx(Fragment, {
        children: Children.map(a, (e, r)=>{
            if (0 === r && isValidElement(e) && !e.props.disabled) {
                var t, o;
                let r = assignRefs(u, 'ref' in e ? e.ref : null !== (o = null === (t = e.props) || void 0 === t ? void 0 : t.ref) && void 0 !== o ? o : null);
                return cloneElement(e, _object_spread_props(_object_spread({}, l), {
                    disabled: 'undefined' !== e.props.disabled ? e.props.disabled : l.disabled,
                    ref: r
                }));
            }
            return e;
        })
    });
}

export { MenuTrigger };
